import { render, staticRenderFns } from "./Comanda.vue?vue&type=template&id=05e2fded&scoped=true&"
import script from "./Comanda.vue?vue&type=script&lang=js&"
export * from "./Comanda.vue?vue&type=script&lang=js&"
import style0 from "./Comanda.vue?vue&type=style&index=0&id=05e2fded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e2fded",
  null
  
)

export default component.exports